import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const buyers = [{
  name: 'María G.',
  location: 'Córdoba'
}, {
  name: 'Julián L.',
  location: 'Buenos Aires'
}, {
  name: 'Carolina P.',
  location: 'La Plata'
}, {
  name: 'Ricardo A.',
  location: 'Mendoza'
}, {
  name: 'Florencia B.',
  location: 'Rosario'
}];
export function FloatingNotification() {
  const [visible, setVisible] = useState(false);
  const [buyer, setBuyer] = useState(buyers[0]);
  useEffect(() => {
    const initial = window.setTimeout(() => setVisible(true), 5000);
    const cycle = window.setInterval(() => {
      setVisible(false);
      window.setTimeout(() => {
        setBuyer(buyers[Math.floor(Math.random() * buyers.length)]);
        setVisible(true);
      }, 850);
    }, 30000);
    return () => {
      window.clearTimeout(initial);
      window.clearInterval(cycle);
    };
  }, []);
  return <AnimatePresence data-id="element-75" data-mp="2fzarl4fkdcbf">{visible && <motion.div initial={{
      opacity: 0,
      y: 35,
      x: -12
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 15,
      scale: .96
    }} transition={{
      type: 'spring',
      stiffness: 380,
      damping: 26
    }} className="fixed bottom-4 left-4 z-50 max-w-sm md:bottom-8 md:left-8" data-id="element-76" data-mp="20wn604p461ul"><div className="flex items-start gap-3 rounded-2xl border border-brand-green/20 bg-white p-4 shadow-xl" data-id="element-77" data-mp="1mw2l92zn1vyg"><div className="mt-0.5 rounded-full bg-brand-green/10 p-2" data-id="element-78" data-mp="1hykbxbhplepx"><CheckCircle2 className="h-5 w-5 text-brand-green" data-id="element-79" data-mp="1d698vzro9ct5" /></div><div data-id="element-80" data-mp="1d4ptschr57sy"><p className="mb-1 text-xs text-brand-muted" data-id="element-81" data-mp="1d4pwik94zlwn">🔔 Compra verificada • hace unos minutos</p><p className="text-sm font-medium text-brand-text" data-id="element-82" data-mp="185d9nzi9meu2"><strong data-id="element-83" data-mp="1394oo5hdzrez">{buyer.name}</strong> de {buyer.location} compró</p><p className="text-sm font-bold text-brand-green" data-id="element-84" data-mp="136ihw82blfxt">Megapack Ventosas Pro™</p></div></div></motion.div>}</AnimatePresence>;
}